module.exports = __webpack_public_path__ + "media/site_templates/www.pest-control.business/images/our_services_2-10d4bbca7ac55b57ae4bde2a89b21a15.jpg";